module.exports = __webpack_public_path__ + "static/img/yishiman.6bc1cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yishiman.png
// module id = 3c6s
// module chunks = 1